import * as Yup from "yup";

export const createDisputeSchema = Yup.object().shape({
  disputeType: Yup.string()
    .oneOf(["AUTHCOMPLAINT", "FRAUD", "CHARGEBACK", "OTHERS"])
    .required("Dispute type is required"),
  reasonForDisputeInDetails: Yup.string()
    .required("Reason is required")
    .min(10, "Please provide a bit more detail"),
});